// Part-time employees are onboarded with employment type "Part-Time", a salary calculation and how many days a month they come.
export const PART_TIME_TYPE = 'Part-Time';
// How a part-timer's per-day salary is worked out.
export const PART_TIME_CALCS = [
    { key: 'GrossCalendarDays', label: 'Gross / Calendar Days', formula: 'Monthly Gross Salary ÷ Total Days in the Month', example: 'e.g., ₹30,000 / 30 calendar days = ₹1,000 per day' },
    { key: 'GrossPartTime', label: 'Gross / Part-Time', formula: 'Monthly Gross Salary ÷ Days the employee is scheduled to come in the month', example: 'e.g., ₹12,000 / 12 scheduled days = ₹1,000 per day (3 days a week)' },
];
export const PART_TIME_CALC = PART_TIME_CALCS[0];
export const calcByKey = (k) => PART_TIME_CALCS.find((c) => c.key === k) || PART_TIME_CALC;

export const isPartTime = (t) => /part[\s-]?time/i.test(String(t || ''));
